import { useMemo } from 'react'

import { type CoreProduct, type CoreItem } from '@flecto/types'

export function useProductToItem(product: Partial<CoreProduct>): Partial<CoreItem> {
  return useMemo(() => {
    if (product.bundle || !product.item_attributes)
      throw new Error('Product is not an item or is missing item_attributes')

    const attrs = product.item_attributes

    return {
      id: product.id,
      internal_id: product.internal_id,
      title: product.title,
      description: product.description,
      status: product.status,
      on_store: product.on_store,
      bundle: false,
      item_type: 'item',
      main_photo: product.main_photo,
      photos: product.photos,
      category_id: product.category_id,
      categories: product.categories,
      insured: product.insured,
      pricing_rules: product.pricing_rules,
      pricing_rule_overtime: product.pricing_rule_overtime!,
      cheapest_booking_cost_cents: product.cheapest_booking_cost_cents,
      cheapest_booking_cost_with_vat_cents:
        product.cheapest_booking_cost_with_vat_cents,
      created_at: product.created_at,
      updated_at: product.updated_at,

      quantity: attrs.quantity,
      quantity_unavailable: attrs.quantity_unavailable,
      discount_by_quantity: attrs.discount_by_quantity,
      idle_minutes: attrs.idle_minutes,
      deposit_amount: attrs.deposit_amount,
      deposit_type: attrs.deposit_type,
      allow_overbooking: attrs.allow_overbooking,
      track_quantity: attrs.track_quantity,
      min_booking_minutes: attrs.min_booking_minutes,
      overtime_enabled: attrs.overtime_enabled,
      tax_rate: attrs.tax_rate,
      taxable: attrs.taxable,
      blocked_quantity: attrs.blocked_quantity,
      unblocked_quantity: attrs.unblocked_quantity,
      ongoing_quantity: attrs.ongoing_quantity,
      ongoing_booking_ids: attrs.ongoing_booking_ids,
      ['can_toggle_track_quantity?']: attrs['can_toggle_track_quantity?'],
    }
  }, [product])
}
